import { Component, OnInit } from '@angular/core';
import { SetupService } from '@core/services/setup';

import { DEPARTMENT_TYPE_PROFESSIONAL } from 'src/app/core/constants';

@Component({
  selector: 'app-professional-home',
  templateUrl: './professional-home.component.html',
  styleUrls: ['./professional-home.component.scss']
})
export class ProfessionalHomeComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Profissional
   */
  public departmentType: string = DEPARTMENT_TYPE_PROFESSIONAL;

  constructor(public setupService: SetupService) { }

  ngOnInit(): void {
  }

}
